export default __webpack_public_path__ + "static/media/Slider-1.2af30c2d.jpg";